import InventoryConversionForm from './InventoryConversionForm';

const InventoryAssembly = () => {
  return <InventoryConversionForm mode="assembly" />;
};

export default InventoryAssembly;
